import React from "react";
import { TextField } from "@mui/material";

const CustomMuiltiLineTextField = ({
  type = "text",
  color,
  fontWeight,
  fontSize,
  error,
  helperText,
  borderColor,
  placeholder,
  placeholderFontSize,
  placeholderColor,
  
  rows,
  
  ...props
}) => {
  return (
    <TextField
      variant="outlined"
      size="small"
      type={type}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
     multiline
      rows={rows}
 
    
      sx={{
        backgroundColor: "#FFFFFF !important",
        borderRadius: "4px",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
          borderColor: borderColor ? borderColor : "#E0E0E0",
          
          "& fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            transition: "border-color 0.3s ease",
          },
          "&:hover fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
          },
          "&.Mui-focused fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            borderWidth: "1px",
          },
        },
        // ✅ Inner input styling
        "& .MuiOutlinedInput-input": {
          backgroundColor: "#FFFFFF",
          fontSize: fontSize ? fontSize : "15px",
          color: color ? color : "#000000",
          borderRadius: "8px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },

        "& input[type=number]": {
          MozAppearance: "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "auto",
          margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "auto",
          margin: 0,
        },
        "& .MuiOutlinedInput-input::placeholder": {
          fontSize: placeholderFontSize ? placeholderFontSize : "13px",
          color: placeholderColor ? placeholderColor : "#888888", // Optional
          fontFamily: "Inter",
          opacity: 0.9,
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};

export default CustomMuiltiLineTextField;
